import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { useAppStatuss, AppStatus } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<AppStatus>
      useData={useAppStatuss}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
